import { inheritsLoose as _inheritsLoose, assertThisInitialized as _assertThisInitialized } from '../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import axios from 'axios';
import DropzoneS3Uploader from 'react-dropzone-s3-uploader';
import styles from './FormUploader.module.scss.js';

var Uploader = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Uploader, _React$Component);
  function Uploader(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.state = {
      preview: null
    };
    _this.getSignedUrl = _this.getSignedUrl.bind(_assertThisInitialized(_this));
    _this.handleFinishedUpload = _this.handleFinishedUpload.bind(_assertThisInitialized(_this));
    _this.onDrop = _this.onDrop.bind(_assertThisInitialized(_this));
    return _this;
  }
  var _proto = Uploader.prototype;
  _proto.getSignedUrl = function getSignedUrl(file, callback) {
    var _this$props = this.props,
      bucket = _this$props.bucket,
      filePath = _this$props.filePath,
      serverUrl = _this$props.serverUrl;
    var params = {
      objectName: file.name,
      bucket: bucket,
      filePath: filePath
    };
    var headers = {
      'Content-Type': 'application/json'
    };
    axios.get(serverUrl, {
      params: params
    }, headers).then(function (response) {
      callback(response.data);
    }).catch(function (error) {
      console.error(error);
    });
  };
  _proto.handleFinishedUpload = function handleFinishedUpload(info) {
    var _this$props2 = this.props,
      input = _this$props2.input,
      progress = _this$props2.progress;
    input && input.onChange(info.signedUrl.split('?')[0]);
    progress(false);
  };
  _proto.onDrop = function onDrop(file) {
    var _this$props3 = this.props,
      customOnDrop = _this$props3.customOnDrop,
      progress = _this$props3.progress;
    this.setState({
      preview: file[0] && file[0].preview
    });
    progress(true);
    customOnDrop(file);
  };
  _proto.render = function render() {
    var options = {
      getSignedUrl: this.getSignedUrl
    };
    var preview = this.state.preview;
    var _this$props4 = this.props,
      s3Url = _this$props4.s3Url,
      child = _this$props4.child,
      className = _this$props4.className,
      filename = _this$props4.filename,
      input = _this$props4.input,
      childStyle = _this$props4.childStyle,
      savedImage = _this$props4.savedImage,
      accept = _this$props4.accept,
      multiple = _this$props4.multiple;
    var Component = child;
    return /*#__PURE__*/React.createElement(DropzoneS3Uploader, {
      className: cx(styles.dropzone, className),
      s3Url: s3Url,
      filename: filename,
      notDropzoneProps: ['onFinish', 's3Url', 'filename', 'host', 'upload', 'isImage', 'notDropzoneProps', 'onDrop'],
      upload: options,
      onDrop: this.onDrop,
      onFinish: this.handleFinishedUpload,
      multiple: multiple,
      name: input.name,
      accept: accept
    }, /*#__PURE__*/React.createElement(Component, {
      childStyle: childStyle,
      preview: preview,
      savedImage: savedImage,
      image: input && input.value
    }));
  };
  return Uploader;
}(React.Component);
Uploader.defaultProps = {
  customOnDrop: function customOnDrop() {
    return null;
  },
  progress: function progress() {
    return null;
  }
};
Uploader.propTypes = {
  /* Give Array List For Accepted File Types Example: ['.csv','.pdf'] */
  accept: PropTypes.array,
  bucket: PropTypes.string,
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  customOnDrop: PropTypes.func,
  filename: PropTypes.string,
  filePath: PropTypes.string,
  input: PropTypes.object,
  /* For Multiple Uploads */
  multiple: PropTypes.bool,
  progress: PropTypes.func,
  s3Url: PropTypes.string
};

export { Uploader as default };
//# sourceMappingURL=index.js.map
